import * as TokenSale from '../contracts/master'
import useWeb3 from './useWeb3'
import { useGetContractByNameQuery } from '../modules/web3/api'
import deepCopy from '../utils/deepCopy'
import useNetworkId from './useNetworkId'
import { ethers } from 'ethers'

const useDynamicMaster = (
  address: string,
  customProvider?: ethers.BrowserProvider | ethers.JsonRpcProvider,
  contractType?: string,
) => {
  const { provider } = useWeb3()
  let _provider: ethers.BrowserProvider | ethers.JsonRpcProvider = provider
  if (customProvider) _provider = customProvider

  const { networkId } = useNetworkId()
  const { data: contractData } = useGetContractByNameQuery(
    { name: contractType, chainId: networkId },
    {
      skip: !contractType,
    },
  )

  const isValid = ethers.isAddress(address)

  const abi = !!contractData ? contractData?.contract?.abi : TokenSale.abi

  const dynamicMaster =
    isValid && !!abi
      ? new ethers.Contract(address, deepCopy(abi), _provider)
      : null

  return dynamicMaster
}

export default useDynamicMaster
